// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const changeSearchTypes = createAction('[Search All Page] Set Search Types', props());
export const changeQueryInput = createAction('[Search All Page] Change Query Input', props());
export const searchChangeCategoryPageNum = createAction('[Search All Page] Change Category Page Num', props());
